(() => {
  if (window.sonneseeWissenFaqListening) return;
  window.sonneseeWissenFaqListening = true;
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.sw-article--darmflora .sw-faq-item')) return;
    details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
  }, true);
})();
